type UnoptimizedToggleProps = {
  /**
   * Number of hidden items when unoptimized toolkits are not shown
   */
  hiddenCount: number;
  /**
   * Whether unoptimized toolkits are currently shown
   */
  isShowingUnoptimized: boolean;
  /**
   * The type of item being hidden (for display text)
   */
  itemType: "toolkit" | "tool";
  /**
   * Callback to toggle the visibility of unoptimized toolkits
   */
  onToggle: () => void;
};

export function UnoptimizedToggle({
  hiddenCount,
  isShowingUnoptimized,
  itemType,
  onToggle,
}: UnoptimizedToggleProps) {
  const pluralItemType = itemType === "toolkit" ? "toolkits" : "tools";

  return (
    <div className="space-y-2 rounded-lg border border-neutral-200 bg-neutral-50 p-3 dark:border-neutral-700 dark:bg-neutral-800/50">
      {!isShowingUnoptimized && hiddenCount > 0 && (
        <p className="text-neutral-600 text-sm dark:text-neutral-400">
          {hiddenCount} {`${hiddenCount === 1 ? itemType : pluralItemType}`}{" "}
          hidden in unoptimized toolkits
        </p>
      )}
      <button
        className="font-medium text-blue-600 text-sm hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
        onClick={onToggle}
        type="button"
      >
        {isShowingUnoptimized
          ? "Hide unoptimized toolkits"
          : "Show unoptimized toolkits"}
      </button>
    </div>
  );
}
